export default __webpack_public_path__ + "static/media/WheelPointerSound.844f523b.mp3";